import Nav from "@/components/marketing/Nav";
import Footer from "@/components/marketing/Footer";

const CONTENT = {
  privacy: {
    title: "Privacy",
    intro: "Holavisto is built around data minimization. We keep what improves your preparation and no more.",
    sections: [
      ["What we handle", "Account details, the applicant information you provide, and the documents you upload for your case. Documents are stored privately and served only through authenticated access."],
      ["Provenance & control", "Every material data point retains its origin (for example, user-declared, document-extracted or reviewer-verified). We never sell personal application data."],
      ["Your rights", "You can request export, correction and deletion of your case data, subject to legal and security controls. Retention is based on legal and service needs, never kept forever by default."],
      ["AI handling", "AI assists with document extraction and comparison only. Extracted document text is treated as untrusted evidence and never as instructions. AI suggestions never silently overwrite your confirmed information."],
    ],
  },
  terms: {
    title: "Terms",
    intro: "By using Holavisto you agree to these terms. Holavisto prepares visa applications; it does not decide them.",
    sections: [
      ["Not a government service", "Holavisto is not a government authority, visa issuer, law firm or appointment reseller. We make no approval guarantees and display no approval probability."],
      ["Your responsibilities", "You are responsible for the accuracy of the information and documents you provide, and for submitting through the official process."],
      ["Human review", "A review of your preparation is a preparation-quality check. It is not a visa decision and does not guarantee any government outcome."],
      ["Acceptable use", "Do not use Holavisto to manufacture, backdate or falsify evidence. We surface inconsistencies as neutral observations to help you prepare honestly."],
    ],
  },
  help: {
    title: "Help centre",
    intro: "Answers to common questions about preparing with Holavisto.",
    sections: [
      ["How do I start?", "Create an account, choose your destination and visa type, then create a case. Holavisto loads the right requirements for your route."],
      ["What are findings?", "Findings are neutral observations, for example a name that differs across documents, with a clear next action. They are not accusations or decisions."],
      ["What does readiness mean?", "Readiness reflects your preparation quality (Not started, In progress, Action needed, Under review, Ready for submission). It is never an approval prediction."],
      ["Is my data safe?", "Original documents are immutable and private. Access is permission-controlled and material actions are audited."],
    ],
  },
};

export default function LegalPage({ page }) {
  const c = CONTENT[page] || CONTENT.help;
  return (
    <div className="min-h-screen bg-softcream">
      <Nav />
      <section className="mx-auto max-w-3xl px-4 py-14 sm:px-6 md:py-20 lg:px-8">
        <h1 className="font-serif text-4xl tracking-tight text-heading md:text-5xl" data-testid="legal-title">{c.title}</h1>
        <p className="mt-4 text-muted">{c.intro}</p>
        <div className="mt-10 space-y-8">
          {c.sections.map(([h, b]) => (
            <div key={h}>
              <h2 className="font-serif text-xl text-heading">{h}</h2>
              <p className="mt-2 leading-relaxed text-muted">{b}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
